import { defineStore } from 'pinia';

export const useUploadStore = defineStore('upload', {
  state: () => ({
    isUploading: false,
  }),
  actions: {
    setIsUploading(status: boolean) {
      this.isUploading = status;
    },
  },
});
